<template>
    <div class="activity-type-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <div class="title-container">
                    <h3>{{ widget.action }} Custom Activity Type</h3>
                </div>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <loading-screen-svg v-if="!fetched"></loading-screen-svg>
            <div class="content-wrapper" v-else>
                <activity-type-form
                    :value="value"
                    @created="handleCreated"
                    @edited="handleEdited"
                    @reset-form="handleReset"
                    :selectedIcon="selectedIcon"
                >
                </activity-type-form>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" :onClick="closeWidget">Cancel</app-button>
                </div>
                <div class="action-container">
                    <app-button :loading="loading" @click="submit">
                        {{ value.id ? 'Save' : 'Add Custom Activity Type' }}
                        <plus-icon-svg colorClass="white" />
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppInput = () => import('@/components/common/app-input');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const ActivityTypeForm = () => import('@/components/sliding-widgets/activity-type-form');
const PlusIconSvg = () => import('@/components/svg/plus-icon-svg');
const AppButton = () => import('@/components/common/app-button');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
export default {
    name: 'activity-type-widget',

    components: {
        'app-input': AppInput,
        'widget-close-svg': WidgetCloseSvg,
        'activity-type-form': ActivityTypeForm,
        'plus-icon-svg': PlusIconSvg,
        'app-button': AppButton,
        'loading-screen-svg': LoadingScreenSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    created() {
        if (this.widget.activityTypeId) {
            this.getActivityType(this.widget.activityTypeId);
            return;
        }

        this.fetched = !this.fetched;
    },

    data() {
        return {
            value: {
                iconColor: {
                    value: '#F30070',
                },
                id: this.widget.activityTypeId,
                name: '',
                accountId: this.widget.accountId,
            },
            selectedIcon: '',
            loading: false,
            fetched: false,
        };
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        submit() {
            this.loading = true;
            EventBus.$emit('custom-activity:submit');
        },

        getActivityType(id) {
            this.$api
                .get(`/Service/CustomActivityTypes?$filter=Id eq ${id}`)
                .then(({ data }) => {
                    const info = data.value[0];
                    this.value.iconColor.value = info.IconColor;
                    this.value.name = info.Name;
                    this.selectedIcon = info.Icon;
                })
                .catch(() => {
                    this.$helpers.showFailNotification(
                        'An error occurred while fetching your custom activity type.',
                        { error },
                    );
                })
                .finally(() => {
                    this.fetched = true;
                });
        },

        handleCreated() {
            this.loading = false;
            EventBus.$emit('custom-log-activities:update');
            this.closeWidget();
        },

        handleEdited() {
            this.loading = false;
            EventBus.$emit('custom-log-activities:update');
            this.closeWidget();
        },

        handleReset() {
            this.loading = false;
        }
    },
};
</script>

<style>
.activity-type-widget .action-container {
    display: flex;
}

.activity-type-widget .action-container .plus-icon-svg {
    margin-left: 8px;
}

.activity-type-widget .action-container .btn {
    margin-left: 15px;
}

.activity-type-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #382153;
    border: 1px solid #877d88;
}

.activity-type-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.activity-type-widget .action-container .btn.transparent-btn .fa.fa-arrow-left {
    margin-right: 16px;
}

.activity-type-widget .action-container .btn.transparent-btn {
    color: #18aeff;
    transition: 0.3s ease-out;
    border: 1px solid #18aeff;
    background: transparent;
}

.activity-type-widget .action-container .btn.transparent-btn:hover {
    transition: 0.2s ease-in-out;
}

.activity-type-widget .action-container .btn.white-btn {
    background: #ffffff;
    color: #877d88;
    border: 2px solid #e9e9ef;
}

.activity-type-widget .loading-screen {
    width: 100%;
    height: calc(100% - 152px);
    overflow: auto;
    padding: 45px 35px;
}
</style>
